import React, { useState, useEffect } from "react";
import { Form, DatePicker, Input, Modal, Spin } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { DATE_FORMAT_FRONTEND, DATE_FORMAT_QUERY } from "../../../constants";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TextButton from "../../Buttons/TextButton";
import { getTranslation } from "../../../utils/helper";
import "./DuplicateRouteForm.scss";
import { doDuplicateRoutePlan } from "../../../modules/routePlan/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

// Extend Day.js with UTC plugin
dayjs.extend(utc);

const DuplicateRouteForm = ({ routePlan, driver, isShow, onClose }) => {
  const [state, setState] = useState({
    isFetching: false,
  });

  const [form] = Form.useForm();
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  useEffect(() => {
    if (isShow) {
      form.setFieldsValue({
        name: `${routePlan?.name} - ${driver?.name}`,
        deliveryDate: routePlan?.deliveryDate ? dayjs(routePlan?.deliveryDate).utc() : null,
      });
    }
  }, [isShow, routePlan, driver]);

  const handleOnFinish = async values => {
    setState({ ...state, isFetching: true });

    form.setFieldsValue({
      name: values.name,
      deliveryDate: values.deliveryDate ? dayjs(values.deliveryDate.format()).utc() : null,
    });

    const params = { ...values };
    params.deliveryDate = values.deliveryDate ? values.deliveryDate.format(DATE_FORMAT_QUERY) : null;
    const response = await doDuplicateRoutePlan({
      id: routePlan._id,
      driverId: driver?._id,
      ...params,
    });
    if (response?.response?._id) {
      window.open(`/route-plans/${response?.response?._id}`, "_blank");
    }

    setState({ ...state, isFetching: false });
    onClose();
  };

  return (
    <Modal open={isShow} onCancel={onClose} footer={[]} width={370} zIndex={9999}>
      <Spin spinning={state.isFetching}>
        <div className="GroupForm RoutePlanForm">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            hideRequiredMark
            colon={false}
            onFinish={handleOnFinish}>
            <div className="FormContent">
              <Form.Item
                label={getTranslation(setting, "Route Plans", "Route Plan Name")}
                name="name"
                rules={[{ required: true, message: "Required" }]}>
                <Input size="large" placeholder={getTranslation(setting, "Route Plans", "Route Plan Name")} />
              </Form.Item>
              <Form.Item
                label={getTranslation(setting, "Route Plans", "Date")}
                name="deliveryDate"
                rules={[{ required: true, message: "Required" }]}>
                <DatePicker
                  size="large"
                  style={{ width: "100%" }}
                  format={DATE_FORMAT_FRONTEND}
                  placeholder={getTranslation(setting, "Route Plans", "Date")}
                />
              </Form.Item>
            </div>
            <div className="FormFooter">
              <div className="Left"></div>
              <div className="Right">
                <TextButton label={getTranslation(setting, "Common", "Cancel")} onClick={onClose} />
                <PrimaryButton
                  label={getTranslation(setting, "Common", "Duplicate")}
                  className="NewButton"
                  htmlType="submit"
                  icon={<ReactSVG className="icon" src="/icons/submit.svg" />}
                />
              </div>
            </div>
          </Form>
        </div>
      </Spin>
    </Modal>
  );
};

export default DuplicateRouteForm;
